import http from "./httpService";
import { FoodsafetyTypes } from "../pages/food-safety";
import { getJwt } from "./authService";
const apiEndpoint = process.env.REACT_APP_API_URL + "/food-safety-issues";

http.setJwt(getJwt()!);

export const postFoodsafety = async (params: FoodsafetyTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });
  return data;
};

export const putFoodsafety = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;

  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default postFoodsafety;
